import { selectorFamily, SerializableParam, useRecoilValue } from 'recoil';
import { InvoiceService } from 'services';
import { isAuthenticated, refreshState, useSetRefreshState } from 'state';
import { InvoiceSummary } from 'types';

type InvoiceParams = {
    accountId: string,
    vendorId: string,
    invoiceId: string,
} & SerializableParam;

export const invoice = selectorFamily<InvoiceSummary | null , InvoiceParams>({
    key: 'invoice',
    get: ({ accountId, vendorId, invoiceId }) => 
        async ({ get }) => {
            get(refreshState(invoice({ accountId, vendorId, invoiceId }).key));
            if (get(isAuthenticated) && accountId && vendorId && invoiceId) {
                const service = new InvoiceService();
                return await service.getInvoiceDetail(accountId, vendorId, invoiceId);
            }
            
            return null;
    }
})

export const useInvoice = (accountId: string, vendorId: string, invoiceId: string) => useRecoilValue(invoice({ accountId, vendorId, invoiceId }));

export const useRefreshInvoice = (accountId: string, vendorId: string, invoiceId: string) => useSetRefreshState(invoice({ accountId, vendorId, invoiceId }));